var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "swiper-container" },
    [
      _c(
        "swiper",
        {
          ref: "heroCarouselDesktop",
          attrs: { options: _vm.heroBannerMobileOptions }
        },
        _vm._l(_vm.slides, function(slide, index) {
          var _obj
          return _c("swiper-slide", { key: index }, [
            _c(
              "div",
              {
                staticClass: "hero-banner",
                class: [
                  _vm.layoutHorizontal,
                  _vm.textAlign,
                  _vm.heroSchema.mobileLayout
                ]
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "hero-banner__container",
                    class: [
                      _vm.layoutVertical,
                      ((_obj = {}),
                      (_obj[slide.mobileBgColor] =
                        _vm.heroSchema.mobileLayout === "below"),
                      _obj)
                    ],
                    attrs: { href: slide.ctaUrl }
                  },
                  [
                    _c("div", {
                      staticClass: "hero-banner__image-mobile",
                      style: "backgroundImage: url(" + slide.imageMobile + ")"
                    }),
                    slide.overlayEnable
                      ? _c("div", {
                          staticClass: "hero-banner__overlay",
                          class: slide.overlayColor,
                          style: { opacity: slide.overlayOpacity }
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "hero-banner__content",
                        class: [_vm.contentProperties.classes],
                        style: Object.assign(
                          {},
                          _vm.contentProperties.style,
                          _vm.slideContainerStyle
                        )
                      },
                      [
                        _c(
                          "h4",
                          {
                            staticClass: "preheader",
                            class: slide.preHeadingColorMobile
                          },
                          [_vm._v(_vm._s(slide.preHeading))]
                        ),
                        _c(
                          "h2",
                          {
                            staticClass: "h1",
                            class: slide.headingColorMobile
                          },
                          [_vm._v(_vm._s(slide.heading))]
                        ),
                        slide.subHeading
                          ? _c(
                              "h3",
                              {
                                staticClass: "subheader",
                                class: slide.subHeadingColorMobile
                              },
                              [_vm._v(_vm._s(slide.subHeading))]
                            )
                          : _vm._e(),
                        slide.copy
                          ? _c(
                              "p",
                              {
                                staticClass: "body-md hero-banner__body-copy",
                                class: slide.bodyCopyColorMobile
                              },
                              [_vm._v(_vm._s(slide.copy))]
                            )
                          : _vm._e(),
                        slide.ctaText
                          ? _c(
                              "div",
                              { staticClass: "hero-banner__cta-wrapper" },
                              [
                                slide.ctaLayout.includes("button")
                                  ? _c(
                                      "v-button",
                                      {
                                        staticClass: "hero-banner__cta",
                                        class: slide.ctaLayout,
                                        attrs: { href: slide.ctaUrl, tag: "a" }
                                      },
                                      [_vm._v(_vm._s(slide.ctaText))]
                                    )
                                  : _vm._e(),
                                slide.ctaLayout.includes("link")
                                  ? _c(
                                      "v-link",
                                      {
                                        staticClass: "hero-banner__cta",
                                        class: slide.ctaLayout,
                                        attrs: { href: slide.ctaUrl }
                                      },
                                      [_vm._v(_vm._s(slide.ctaText))]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        }),
        1
      ),
      _c(
        "div",
        {
          staticClass: "controls-container",
          class: [
            _vm.heroSchema.mobileLayout,
            { "controls-container--text-box": _vm.heroSchema.enableTextBox }
          ]
        },
        [
          _c(
            "div",
            { staticClass: "pagination-dots" },
            _vm._l(_vm.slides, function(slide, index) {
              return _c("div", {
                key: "dot-" + index,
                staticClass: "dot",
                class: [_vm.dotActive(index), "dot-" + index],
                on: {
                  click: function($event) {
                    return _vm.slidePagination(index)
                  }
                }
              })
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }